export const defaultMetadata = {
	title: "Jace AI",
	description: "Coming soon to a browser near you",
};

export const INBOX_PATH = "/inbox";
export const CHAT_PATH = "/chat";

export const GOOGLE_TAG_MANAGER_ID =
	process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

export const POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY as string;
export const GLEAP_API_KEY = process.env.NEXT_PUBLIC_GLEAP_API_KEY as string;
export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV as string;

export const LANDING_URL = "https://jace.ai";
export const PRIVACY_URL = `${LANDING_URL}/privacy`;
export const TERMS_URL = `${LANDING_URL}/terms`;
export const TEAM_EMAIL = "team@jace.ai";
export const DISCORD_URL = "https://discord.gg/EnQCG3eFPd";
export const LINKEDIN_URL = "https://www.linkedin.com/company/zetaai/";
export const X_URL = "https://x.com/jace_ai";
export const YOUTUBE_URL =
	"https://www.youtube.com/channel/UC19cHiXUvbh689yNEowobeg";
export const OUTLOOK_WAITLIST_URL = "https://getwaitlist.com/waitlist/24757";

export const CHROME_EXTENSION_ID = "kpenfcpkapflafeokmpbchgjomkmffog";
export const CHROME_EXTENSION_URL = `https://chromewebstore.google.com/detail/${CHROME_EXTENSION_ID}`;

export const BACKFILL_STATUS_COOKIE = "backfillStatus";
export const REFERRAL_CODE_COOKIE = "refCode";
export const AUTH_TOKEN_COOKIE = "token";

export const sharedCookieOptions = {
	// We want to have access to the cookie on jace.ai LP
	domain:
		process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
			? ".jace.ai"
			: undefined,
	path: "/",
	secure: true,
	sameSite: "lax",
} as const;

export const ENABLE_GUIDED_TOUR = true;
